export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_CHECK = 'AUTH_CHECK';
export const IS_LOADING = 'IS_LOADING';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_TOKEN = 'AUTH_TOKEN';
export const AUTH_SWITCHUSER = 'AUTH_SWITCHUSER';
export const AUTH_SWITCHUSER_FALSE ='AUTH_SWITCHUSER_FALSE';
//* for sidebar
export const ACTIVE_MENU = 'ACTIVE_MENU';